import type { StoreProduct } from "@/platform/api/store-contract"
import { isRenderableImageUrl } from "@/platform/images/hosts"

export const galleryImages = (product: StoreProduct): string[] => {
  const urls = [...new Set((product.images ?? []).map(({ url }) => url).filter(isRenderableImageUrl))]
  const thumbnail = product.thumbnail
  if (!thumbnail || !isRenderableImageUrl(thumbnail)) return urls
  return [thumbnail, ...urls.filter((url) => url !== thumbnail)]
}
